<template>
  <div id="result-box">
    <div v-if="isNoResult===false" class="my-result one-city--xosotv">
      <div class="result-table">
        <div class="result-head">
          <img src="/assets/images/bar8-hd.png">
        </div>
        <div class="result-body">
          <div class="result-row">
            <div class="col col-title">Đặc biệt</div>
            <div class="col col-1 text-26">
              <div class="col-inner">
                <ShowNumbers length="5" :results="resultNumbers" result-key="prize_1st" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
              </div>
            </div>
          </div>
          <div class="result-row bg">
            <div class="col col-title">Giải nhất</div>
            <div class="col col-1 text-20">
              <div class="col-inner">
                <ShowNumbers length="5" :results="resultNumbers" result-key="prize_2nd" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
              </div>
            </div>
          </div>
          <div class="result-row">
            <div class="col col-title">Giải nhì</div>
            <div class="col col-2 text-20">
              <div class="col-inner">
                <ShowNumbers length="5" :results="resultNumbers" result-key="prize_3rd_1" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
              </div>
            </div>
            <div class="col col-2 text-20">
              <div class="col-inner">
                <ShowNumbers length="5" :results="resultNumbers" result-key="prize_3rd_2" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
              </div>
            </div>
          </div>
          <div class="result-row bg">
            <div class="col col-title">Giải ba</div>
            <div class="col-6 text-20">
              <div class="col">
                <div class="col-inner">
                  <ShowNumbers length="5" :results="resultNumbers" result-key="prize_4th_1" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
                </div>
              </div>
              <div class="col">
                <div class="col-inner">
                  <ShowNumbers length="5" :results="resultNumbers" result-key="prize_4th_2" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
                </div>
              </div>
              <div class="col">
                <div class="col-inner">
                  <ShowNumbers length="5" :results="resultNumbers" result-key="prize_4th_3" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
                </div>
              </div>
              <div class="col no-border">
                <div class="col-inner">
                  <ShowNumbers length="5" :results="resultNumbers" result-key="prize_4th_4" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
                </div>
              </div>
              <div class="col no-border">
                <div class="col-inner">
                  <ShowNumbers length="5" :results="resultNumbers" result-key="prize_4th_5" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
                </div>
              </div>
              <div class="col no-border">
                <div class="col-inner">
                  <ShowNumbers length="5" :results="resultNumbers" result-key="prize_4th_6" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
                </div>
              </div>
            </div>
          </div>
          <div class="result-row">
            <div class="col col-title">Giải tư</div>
            <div class="col col-4 text-20">
              <div class="col-inner">
                <ShowNumbers length="4" :results="resultNumbers" result-key="prize_5th_1" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
              </div>
            </div>
            <div class="col col-4 text-20">
              <div class="col-inner">
                <ShowNumbers length="4" :results="resultNumbers" result-key="prize_5th_2" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
              </div>
            </div>
            <div class="col col-4 text-20">
              <div class="col-inner">
                <ShowNumbers length="4" :results="resultNumbers" result-key="prize_5th_3" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
              </div>
            </div>
            <div class="col col-4 text-20">
              <div class="col-inner">
                <ShowNumbers length="4" :results="resultNumbers" result-key="prize_5th_4" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
              </div>
            </div>
          </div>
          <div class="result-row bg">
            <div class="col col-title">Giải năm</div>
            <div class="col-6 text-20">
              <div class="col">
                <div class="col-inner">
                  <ShowNumbers length="4" :results="resultNumbers" result-key="prize_6th_1" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
                </div>
              </div>
              <div class="col">
                <div class="col-inner">
                  <ShowNumbers length="4" :results="resultNumbers" result-key="prize_6th_2" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
                </div>
              </div>
              <div class="col">
                <div class="col-inner">
                  <ShowNumbers length="4" :results="resultNumbers" result-key="prize_6th_3" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
                </div>
              </div>
              <div class="col no-border">
                <div class="col-inner">
                  <ShowNumbers length="4" :results="resultNumbers" result-key="prize_6th_4" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
                </div>
              </div>
              <div class="col no-border">
                <div class="col-inner">
                  <ShowNumbers length="4" :results="resultNumbers" result-key="prize_6th_5" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
                </div>
              </div>
              <div class="col no-border">
                <div class="col-inner">
                  <ShowNumbers length="4" :results="resultNumbers" result-key="prize_6th_6" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
                </div>
              </div>
            </div>
          </div>
          <div class="result-row">
            <div class="col col-title">Giải sáu</div>
            <div class="col col-3 text-20">
              <div class="col-inner">
                <ShowNumbers length="3" :results="resultNumbers" result-key="prize_7th_1" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
              </div>
            </div>
            <div class="col col-3 text-20">
              <div class="col-inner">
                <ShowNumbers length="3" :results="resultNumbers" result-key="prize_7th_2" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
              </div>
            </div>
            <div class="col col-3 text-20">
              <div class="col-inner">
                <ShowNumbers length="3" :results="resultNumbers" result-key="prize_7th_3" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
              </div>
            </div>
          </div>
          <div class="result-row bg">
            <div class="col col-title">Giải bảy </div>
            <div class="col col-4 text-26">
              <div class="col-inner">
                <ShowNumbers length="2" :results="resultNumbers" result-key="prize_2digits_1" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
              </div>
            </div>
            <div class="col col-4 text-26">
              <div class="col-inner">
                <ShowNumbers length="2" :results="resultNumbers" result-key="prize_2digits_2" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
              </div>
            </div>
            <div class="col col-4 text-26">
              <div class="col-inner">
                <ShowNumbers length="2" :results="resultNumbers" result-key="prize_2digits_3" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
              </div>
            </div>
            <div class="col col-4 text-26">
              <div class="col-inner">
                <ShowNumbers length="2" :results="resultNumbers" result-key="prize_2digits_4" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
              </div>
            </div>
          </div>
        </div>
        <div class="result-footer">
          <img src="/assets/images/r-footer-hd.png">
        </div>
      </div>
    </div>
    <div style="background-color: #FFF; margin-top: 10px;">
      <a href="https://xosoextra.com/" target="_blank">
        <img src="/assets/images/extra550x450.png" class="banner">
      </a>
    </div>
    <div style="background-color: #FFF; margin-top: 10px;">
      <img src="/assets/images/bn15-hd.png" class="banner">
    </div>
    <div style="background-color: #FFF; margin-top: 10px;">
      <img src="/assets/images/bn16-hd.png" class="banner">
    </div>
  </div>
</template>
<script>
import { slotItems } from '@/configs/slot.config.js'
import LottoService from '@/services/lottoService.js'

import ShowNumbers from './ShowNumbers.vue'

export default {
  name: 'ResultBox',
  components: {
    ShowNumbers
  },
  data() {
    return {
      resultDate: null,
      currentResult: null,
      distance: 20, // ระยะห่างของการออกแต่ล่ะเลข (วินาที)
      slotCounting: null,
      IntervalReload: null,
      setTimeoutToshow: null,
      updateTime: null,
      isNoResult: false
    }
  },
  computed: {
    checkUpdate() {
      return `${this.startSpin}-${this.startShow}-${this.prize1st}-${this.prize2nd}-${this.endTime}-${this.slotCounting}`
    },
    drawDate() {
      if (!this.currentResult)
        return '-'

      let date = this.$moment(this.currentResult.lotto_date)
      return date.format("DD/MM/YYYY")
    },
    resultNumbers() {
      if (this.currentResult !== null) {
        return this.currentResult.results
      } else {
        return null
      }
    },
    updateCode() {
      return this.updateTime
    },
    startSpin() {
      if (this.currentResult !== null) {
        return this.currentResult.start_spin
      }
      return null
    },
    startShow() {
      if (this.currentResult !== null && this.currentResult.show_2nd) {
        return this.currentResult.show_2nd
      }
      return null
    },
    endTime() {
      if (this.currentResult !== null && this.currentResult.show_1st) {
        return this.currentResult.show_1st
      }
      return null
    },
  },
  watch: {
    checkUpdate() {
      this.updateTime = new Date().getTime()
      this.calProcess()
    }
  },
  methods: {
    getResult() {
      LottoService.getResult(this.resultDate).then((response)=>{
        if (response.status === 'success') {
          this.currentResult = response.data
        }else{
          this.isNoResult = true
        }
      })
    },
    calProcess() {
      console.log('calProcess...')
      if(this.currentResult.show_2nd) {
        if(this.endTime!==null && this.$moment().isAfter(this.endTime)) {
          this.slotCounting = slotItems[slotItems.length - 1]
          //this.updateTime = new Date().getTime()
        }else
        // ยังไม่ถึงเวลาแสดงค่าแรก
        if(this.$moment().isBefore(this.currentResult.show_2nd)) {
          this.slotCounting = null
          let diff = this.$moment(this.currentResult.show_2nd).diff(this.$moment(), 'milliseconds')
          clearTimeout(this.setTimeoutToshow)
          this.setTimeoutToshow = setTimeout(() => {
            this.calProcess()
          }, diff)
        // ถึงเวลาแสดงค่าแรก
        }else{
          // ระยะเวลาหลังจากแสดงค่าแรก
          let diff = this.$moment().diff(this.$moment(this.currentResult.show_2nd), 'milliseconds')
          let slotIndex = Math.floor(Math.abs(diff) / (this.distance*1000))
          //this.updateTime = new Date().getTime()
          if (slotIndex < slotItems.length) {
            this.slotCounting = slotItems[slotIndex]
          } else {
            this.slotCounting = slotItems[slotItems.length - 1]
          }
        }
      }
    }
  },
  created() {
    this.resultDate = this.$route.params.pathDate
    this.getResult()
    this.IntervalReload = setInterval(() => {
      this.getResult()
    }, 45000)
  },
  beforeDestroy() {
    clearTimeout(this.setTimeoutToshow)
    clearInterval(this.IntervalReload)
  }
}
</script>
<style lang="scss" scoped>
#result-box {
  .my-result {
    .result-table {
      .result-head {
        margin-bottom: 5px;
        img {
          width: 100%;
          max-width: 100%;
        }
      }
      .result-body {
        .result-row {
          border-top: 1px solid #ccc;
          display: flex;
          flex-wrap: wrap;

          &.bg {
            background-color: #EFEFEF;
          }

          .col {
            padding: 0;
            margin: 0;

            .col-inner {
              display: flex;
              min-height: 40px;
              align-items: center;
              justify-content: center;
              border-left: 1px solid #ccc;
              width: 100%;
              height: 100%;
            }
          }

          .col-title {
            display: flex;
            min-height: 40px;
            align-items: center;
            justify-content: center;
            -ms-flex: 0 0 20%;
            flex: 0 0 20%;
            max-width: 20%;
          }

          .col-1 {
            -ms-flex: 0 0 80%;
            flex: 0 0 80%;
            max-width: 80%;
          }

          .col-2 {
            -ms-flex: 0 0 40%;
            flex: 0 0 40%;
            max-width: 40%;
          }

          .col-3 {
            -ms-flex: 0 0 26.6667%;
            flex: 0 0 26.6667%;
            max-width: 26.6667%;
          }

          .col-4 {
            -ms-flex: 0 0 20%;
            flex: 0 0 20%;
            max-width: 20%;
          }

          .col-6 {
            -ms-flex: 0 0 80%;
            flex: 0 0 80%;
            max-width: 80%;
            display: flex;
            flex-wrap: wrap;

            .col {
              display: flex;
              -ms-flex: 0 0 33.3333%;
              flex: 0 0 33.3333%;
              max-width: 33.3333%;
              border-bottom: 1px solid #ccc;

              &.no-border {
                border-bottom: 0;
              }
            }
          }

          .text-26 {
            font-size: 26px;
            color: #e80000;
          }
          .text-20 {
            font-size: 20px;
          }
        }
      }
      .result-footer {
        img {
          width: 100%;
          max-width: 100%;
        }
      }
    }
  }
}
</style>
